/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderSystemInfoDto
 */
export interface OrderSystemInfoDto {
    /**
     * Идентификатор объекта размещения
     * @type {string}
     * @memberof OrderSystemInfoDto
     */
    propertyId: string;
    /**
     * Идентификатор тарифного плана
     * @type {string}
     * @memberof OrderSystemInfoDto
     */
    ratePlanId: string;
    /**
     * Идентификатор типа комнаты
     * @type {string}
     * @memberof OrderSystemInfoDto
     */
    roomTypeId: string;
    /**
     * Чексумма по выбранному номеру
     * @type {string}
     * @memberof OrderSystemInfoDto
     */
    checksum: string;
}

/**
 * Check if a given object implements the OrderSystemInfoDto interface.
 */
export function instanceOfOrderSystemInfoDto(value: object): value is OrderSystemInfoDto {
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    if (!('ratePlanId' in value) || value['ratePlanId'] === undefined) return false;
    if (!('roomTypeId' in value) || value['roomTypeId'] === undefined) return false;
    if (!('checksum' in value) || value['checksum'] === undefined) return false;
    return true;
}

export function OrderSystemInfoDtoFromJSON(json: any): OrderSystemInfoDto {
    return OrderSystemInfoDtoFromJSONTyped(json, false);
}

export function OrderSystemInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderSystemInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'propertyId': json['propertyId'],
        'ratePlanId': json['ratePlanId'],
        'roomTypeId': json['roomTypeId'],
        'checksum': json['checksum'],
    };
}

  export function OrderSystemInfoDtoToJSON(json: any): OrderSystemInfoDto {
      return OrderSystemInfoDtoToJSONTyped(json, false);
  }

  export function OrderSystemInfoDtoToJSONTyped(value?: OrderSystemInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'propertyId': value['propertyId'],
        'ratePlanId': value['ratePlanId'],
        'roomTypeId': value['roomTypeId'],
        'checksum': value['checksum'],
    };
}

